import { createContext } from "react";

export const GTMProjectContext = createContext();
